// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader-enter-active[data-v-28f7f7e8],.loader-leave-active[data-v-28f7f7e8]{transition:all .5s cubic-bezier(.55,0,.1,1)}.loader-enter[data-v-28f7f7e8],.loader-leave-active[data-v-28f7f7e8]{opacity:0}.a-svg-logo-x9[data-v-28f7f7e8]{pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
